import {Link} from "react-router-dom";
import * as React from "react";
import {cx} from "emotion";
import ReactTooltip from 'react-tooltip';

import "./template-view-more.scss";

import {cs}             from "@Common/react/chain-services";
import {singleValue}    from "@Common/utils/objects";

export const rTemplateViewMore = (template, isManagerTool, {viewMode}) => cs(
    ({}) => (
        <Link
            className={cx("template-view-more-item-4d6", viewMode)}
            to={isManagerTool ? `/manage-templates/private#new-template-upload-modal-${template.id}-new` : `/product-options/${template.sourceTemplateId}/${template.id}`}
            xd-qa-type="template"
        >
            <ReactTooltip place="right" type="dark" effect="float" delayShow={500}/>

            <div
                className="content"
            >
                <div
                    className="img"
                    style={{backgroundImage: `url('${singleValue(template.images)?.url}')`}}
                >

                </div>
                <div
                    className="name"
                    data-tip={template.name}
                >
                    {template.name}
                </div>

                <div className="details">
                    <div
                        className="line name"
                        data-tip={template.name}
                    >
                        {template.product.name}
                    </div>
                    <div
                        className="line info"
                    >
                        <div className="label">
                            Finished size
                        </div>
                        <div className="value">
                            : {template.product.finishedWidth} x {template.product.finishedHeight}
                        </div>
                    </div>
                    <div
                        className="line info"
                    >
                        <div className="label">
                            Flat size
                        </div>
                        <div className="value">
                            : {template.product.flatWidth} x {template.product.flatHeight}
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    ),
);